import {
  DashboardVideoDetail,
  UpdateDashboardVideoInput,
} from 'models/DashboardVideo';

export interface VideoEditDraft {
  title: string;
  description: string;
  isMandatory: boolean;
  /** true si el admin subió un .mp4 nuevo en esta sesión del modal. */
  videoReplaced: boolean;
  r2Key: string | null;
  durationSeconds: number | null;
  /** Estado final del thumbnail: null = sin thumbnail; string = key actual. */
  thumbnailR2Key: string | null;
  discardedR2Keys: string[];
}

/** Agrega una key al acumulador de descartes (ignora vacíos, evita duplicados). */
export const appendDiscarded = (
  list: string[],
  key: string | null | undefined
): string[] => {
  if (!key) return list;
  if (list.includes(key)) return list;
  return [...list, key];
};

/** Arma el patch parcial: solo los campos que cambiaron respecto al original. */
export const buildUpdatePayload = (
  original: DashboardVideoDetail,
  draft: VideoEditDraft
): UpdateDashboardVideoInput => {
  const body: UpdateDashboardVideoInput = {};

  if (draft.title !== original.title) body.title = draft.title;
  if (draft.description !== original.description)
    body.description = draft.description;
  if (draft.isMandatory !== original.isMandatory)
    body.isMandatory = draft.isMandatory;

  if (draft.videoReplaced && draft.r2Key && draft.durationSeconds) {
    body.r2Key = draft.r2Key;
    body.durationSeconds = draft.durationSeconds;
  }

  // Tri-estado: comparar el estado final contra el original.
  if (draft.thumbnailR2Key !== original.thumbnailR2Key) {
    body.thumbnailR2Key = draft.thumbnailR2Key;
  }

  if (draft.discardedR2Keys.length > 0) {
    body.discardedR2Keys = draft.discardedR2Keys;
  }

  return body;
};
